import { makeCall, Methods } from "../../utils/makeCall";
import {
  CampaignErrors,
  GetAdJoinReportError,
  GetAvailableCampaignStartDateErrors,
  GetCampaignPaymentTokenErrors,
  GetDefaultCampaignPackagesErrors,
  GetPaymentTokenErrors,
  GetUserCustomCampaignPackageErrors,
  SubmitAdOrderErrors,
  SubmitBusinessAdOrderErrors,
} from "./orderAd.error";
import {
  ApiAdRecord,
  ApiCampaignAdRecord,
  CampaignPackage,
  CampaignPackageType,
} from "./orderAd.entity";

export type SubmitAdOrderRequest = Partial<
  Pick<
    ApiAdRecord,
    | "spot"
    | "title"
    | "description"
    | "link"
    | "link_title"
    | "view_count"
    | "click_count"
    | "desired_start_time"
    | "topic"
    | "pic_url"
    | "tag_1"
    | "tag_2"
    | "sponsored_message_options"
    | "target_type"
    | "target_ids"
  >
>;
export type SubmitAdOrderResponse = undefined;

export const submitAdOrder = makeCall<
  SubmitAdOrderRequest,
  SubmitAdOrderResponse,
  SubmitAdOrderErrors
>(Methods.SubmitAdOrder);

export type GetPaymentTokenRequest = {
  ad_id: string;
  bonus_code?: string;
  start_date: string;
  start_day: number;
};

export type GetPaymentTokenResponse = {
  token: string;
};

export const getPaymentToken = makeCall<
  GetPaymentTokenRequest,
  GetPaymentTokenResponse,
  GetPaymentTokenErrors
>(Methods.GetPaymentToken);

export type SubmitBusinessAdOrderRequest = {
  name: string;
  phone_no: string;
  link: string;
  spot: number;
};
export type SubmitBusinessAdOrderResponse = undefined;

export const SubmitBusinessAdOrder = makeCall<
  SubmitBusinessAdOrderRequest,
  SubmitBusinessAdOrderResponse,
  SubmitBusinessAdOrderErrors
>(Methods.SubmitBusinessAdOrder);

export type CreateCampaignRequest = {
  ads: Partial<ApiCampaignAdRecord>[];
  stop_value?: number;
};
export type CreateCampaignResponse = undefined;

export const CreateCampaign = makeCall<
  CreateCampaignRequest,
  CreateCampaignResponse,
  CampaignErrors
>(Methods.CreateCampaign);

export type GetAvailableCampaignStartDateRequest = void;
export type GetAvailableCampaignStartDateResponse = {
  date: number;
};

export const GetAvailableCampaignStartDate = makeCall<
  GetAvailableCampaignStartDateRequest,
  GetAvailableCampaignStartDateResponse,
  GetAvailableCampaignStartDateErrors
>(Methods.GetAvailableCampaignStartDate);

export type GetDefaultCampaignPackagesRequest = void;

export type GetDefaultCampaignPackagesResponse = {
  basic: CampaignPackage;
  advanced: CampaignPackage;
  business: CampaignPackage;
};

export const GetDefaultCampaignPackages = makeCall<
  GetDefaultCampaignPackagesRequest,
  GetDefaultCampaignPackagesResponse,
  GetDefaultCampaignPackagesErrors
>(Methods.GetDefaultCampaignPackages);

export type GetCampaignPaymentTokenRequest = {
  package_type: CampaignPackageType;
};
export type GetCampaignPaymentTokenResponse = {
  token: string;
};

export const GetCampaignPaymentToken = makeCall<
  GetCampaignPaymentTokenRequest,
  GetCampaignPaymentTokenResponse,
  GetCampaignPaymentTokenErrors
>(Methods.GetCampaignPaymentToken);

export type GetUserCustomCampaignPackageRequest = void;
export type GetUserCustomCampaignPackageResponse = {
  allowed_concurrent_campaigns: number;
  daily_view_capacity: number;
  credit_expire_days: number;
  base_credit: number;
};

export const GetUserCustomCampaignPackage = makeCall<
  GetUserCustomCampaignPackageRequest,
  GetUserCustomCampaignPackageResponse,
  GetUserCustomCampaignPackageErrors
>(Methods.GetUserCustomCampaignPackage);

export type GetAdJoinReportRequest = {
  ad_id: string;
};

export type GetAdJoinReportResponse = {
  ad_id: string;
  join_segments: number[] | null;
  left_segments: number[] | null;
  start_time: string;
  finish_time: string;
};
export const GetAdJoinReport = makeCall<
  GetAdJoinReportRequest,
  GetAdJoinReportResponse,
  GetAdJoinReportError
>(Methods.GetAdJoinReport);
